import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import useGetUserProfile from '../../../../common/category/useGetUserProfile'
import useViewport from '../../../../common/hooks/useViewport'
import { Button } from '../../../../common/html/button'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { PanelContainer } from '../../../../common/panel/PanelContainer'
import { TYPE_PACKAGE_SUBSCRIPTION } from '../constants'
import classes from '../index.module.scss'
import {
  selectDetailRequestInfoAll,
  selectLoadingRequestConfirmation,
} from '../store/slice'
import {
  getDetailRequestConfirmation,
  getSubscriptionAndPackageOrdersById,
} from '../store/thunk'
import { CancelBtn } from './CancelBtn'
import { DetailTable } from './DetailTable'
import { NavigateBackButton } from './NavigateBackButton'
import { RequestInformation } from './RequestInformation'

export const RequestDetail = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { loading } = useGetUserProfile()
  const { width, height } = useViewport()
  const loadingRequestConfirmation = useSelector(
    selectLoadingRequestConfirmation,
  )
  const detailRequestInfo = useSelector(selectDetailRequestInfoAll)
  const locale = useSelector((state) => state.i18n.locale)

  const { requestId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  const isPackageRequest =
    detailRequestInfo?.orderType === TYPE_PACKAGE_SUBSCRIPTION.PACKAGE

  const handleDownloadConfirmation = () => {
    dispatch(getDetailRequestConfirmation({ Id: requestId }))
  }

  useEffect(() => {
    dispatch(getSubscriptionAndPackageOrdersById({ Id: requestId }))
  }, [locale])

  if (loading) return <Loading />

  return (
    <div className={classes.detailContainer}>
      <NavigateBackButton />
      <Element className={classes.title} style={{ fontSize: 20 }}>
        <Translate value="userManagement.packageSubManagement.DETAIL_REQUEST" />
      </Element>
      <PanelContainer>
        <RequestInformation
          requestId={requestId}
          isPackageRequest={isPackageRequest}
        />
        {isPackageRequest && <DetailTable />}
      </PanelContainer>
      <div className={['dFlex justifyContentEnd', classes.footer].join(' ')}>
        <CancelBtn
          snpOrderId={+requestId}
          requestedToCancel={detailRequestInfo?.requestedToCancel || false}
          requestStatus={detailRequestInfo?.status}
        />
        <Button
          action={handleDownloadConfirmation}
          isI18n
          label="userManagement.packageSubManagement.DOWNLOAD_CONFIRMATION"
          style={{
            border: 'none',
            backgroundColor: '#0553A5',
            color: '#FFFFFF',
          }}
        />
        {createPortal(
          <div
            style={{
              display: loadingRequestConfirmation ? 'block' : 'none',
              width,
              height,
            }}
            className={classes.loadingContainer}
          >
            <div className="wh100 positionRelative">
              <Loading />
            </div>
          </div>,
          document.body,
        )}
      </div>
    </div>
  )
}
